// When the app opens (and when the server reports new uploads), bring the phone's copies up to date in the background,
// so Inventory, Library, Research and My eBay listings open from the phone with no waiting.
import { api } from "@/lib/api";
import { remoteChange, setRemoteChange } from "@/lib/cache";
import { syncInventory, syncListings } from "@/lib/localCopy";
import { syncDrafts, syncResearch } from "@/lib/localLibrary";

let running = null;

export function prefetchData(user) {
  if (running || !user) return running;
  running = (async () => {
    const latest = remoteChange() || await api.get("/changes/latest", { fresh: true }).then((r) => r.data.latest).catch(() => "");
    setRemoteChange(latest);
    const jobs = user.team_role ? [syncResearch] : [syncInventory, syncDrafts, syncResearch, syncListings];
    for (const job of jobs) {
      try { await job(); } catch { /* next open tries again */ }
    }
  })().finally(() => { running = null; });
  return running;
}
